import React from 'react';
import { 
  Box, 
  Skeleton, 
  Grid, 
  Paper, 
  Divider,
  Stack
} from '@mui/material';

const JobDescriptionSkeleton = () => {
  return (
    <Box sx={{ width: '100%', height:'60vh',  p: 2 }}>
      <Grid container spacing={3}>
        {/* Left Column (Job Details) */}
        <Grid item xs={12} md={8}>
          {/* Job Header Skeleton */}
          <Paper sx={{ 
            p: 3, 
            mb: 3,
            background: 'linear-gradient(90deg, rgba(0, 0, 105, 0.1) 0%, rgba(0, 212, 255, 0.1) 100%)',
            borderRadius: 2
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <Skeleton variant="text" width={300} height={50} sx={{ mb: 2 }} />
                <Skeleton variant="text" width={200} height={30} sx={{ mb: 2 }} />
              </Box>
              <Skeleton variant="circular" width={40} height={40} />
            </Box>
            
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                  <Skeleton variant="text" width={150} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                  <Skeleton variant="text" width={100} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                  <Skeleton variant="text" width={120} />
                </Box>
              </Grid>
            </Grid>
            
            <Divider sx={{ my: 2 }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                <Skeleton variant="text" width={100} />
              </Box>
              <Box>
                <Skeleton variant="rectangular" width={80} height={36} sx={{ mr: 1, borderRadius: 1 }} />
              </Box>
            </Box>
          </Paper>
          
          {/* Job Description Skeleton */}
          <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
            <Skeleton variant="text" width={150} height={40} sx={{ mb: 2 }} />
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={80} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={100} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={120} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={90} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={50} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
            
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width={60} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" />
            </Box>
          </Paper>
          
          {/* Skills Section Skeleton */}
          <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
            <Skeleton variant="text" width={100} height={30} sx={{ mb: 2 }} />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {[...Array(8)].map((_, i) => (
                <Skeleton key={i} variant="rectangular" width={100} height={32} sx={{ borderRadius: 16 }} />
              ))}
            </Box>
          </Paper>
          
          {/* Job Summary Skeleton */}
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Skeleton variant="text" width={100} height={40} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="100%" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="100%" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="90%" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="95%" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="85%" sx={{ mb: 1 }} />
          </Paper>
        </Grid>
        
        {/* Right Column (Candidate Search) */}
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
            
            {/* Search Input Skeleton */}
            <Skeleton variant="rectangular" width="100%" height={56} sx={{ mb: 3, borderRadius: 1 }} />
            
            {/* Candidate List Skeleton */}
            <Stack spacing={3}>
              {[...Array(4)].map((_, i) => (
                <Box key={i}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                    <Skeleton variant="text" width={100} />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 6 }}>
                    <Skeleton variant="text" width={150} />
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 6 }}>
                    <Skeleton variant="text" width={100} sx={{ mr: 2 }} />
                    <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                  </Box>
                </Box>
              ))}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JobDescriptionSkeleton;